export const SORT_PRETTY_NAME = {
  "votes": "Top", 
  "time": "Recent"
}

export const ERA_PRETTY_NAME = {
  "day": "Today",
  "week": "This Week",
  "month": "This Month",
  "year": "This Year",
  "all": "All Time",
}

export const COUNTRY_NAMES = {
  "WW": "Worldwide",
  "BD": "Bangladesh", 
  "BE": "Belgium", 
  "BF": "Burkina Faso", 
  "BG": "Bulgaria", 
  "BA": "Bosnia and Herzegovina", 
  "BB": "Barbados", 
  "WF": "Wallis and Futuna", 
  "BL": "Saint Barthelemy", 
  "BM": "Bermuda", 
  "BN": "Brunei", 
  "BO": "Bolivia", 
  "BH": "Bahrain", 
  "BI": "Burundi", 
  "BJ": "Benin", 
  "BT": "Bhutan", 
  "JM": "Jamaica", 
  "BV": "Bouvet Island", 
  "BW": "Botswana", 
  "WS": "Samoa", 
  "BQ": "Bonaire, Saint Eustatius and Saba ", 
  "BR": "Brazil", 
  "BS": "Bahamas", 
  "JE": "Jersey", 
  "BY": "Belarus", 
  "BZ": "Belize", 
  "RU": "Russia", 
  "RW": "Rwanda", 
  "RS": "Serbia", 
  "TL": "East Timor", 
  "RE": "Reunion", 
  "TM": "Turkmenistan", 
  "TJ": "Tajikistan", 
  "RO": "Romania", 
  "TK": "Tokelau", 
  "GW": "Guinea-Bissau", 
  "GU": "Guam", 
  "GT": "Guatemala", 
  "GS": "South Georgia and the South Sandwich Islands", 
  "GR": "Greece", 
  "GQ": "Equatorial Guinea", 
  "GP": "Guadeloupe", 
  "JP": "Japan", 
  "GY": "Guyana", 
  "GG": "Guernsey", 
  "GF": "French Guiana", 
  "GE": "Georgia", 
  "GD": "Grenada", 
  "GB": "United Kingdom", 
  "GA": "Gabon", 
  "SV": "El Salvador", 
  "GN": "Guinea", 
  "GM": "Gambia", 
  "GL": "Greenland", 
  "GI": "Gibraltar", 
  "GH": "Ghana", 
  "OM": "Oman", 
  "TN": "Tunisia", 
  "JO": "Jordan", 
  "HR": "Croatia", 
  "HT": "Haiti", 
  "HU": "Hungary", 
  "HK": "Hong Kong", 
  "HN": "Honduras", 
  "HM": "Heard Island and McDonald Islands", 
  "VE": "Venezuela", 
  "PR": "Puerto Rico", 
  "PS": "Palestinian Territory", 
  "PW": "Palau", 
  "PT": "Portugal", 
  "SJ": "Svalbard and Jan Mayen", 
  "PY": "Paraguay", 
  "IQ": "Iraq", 
  "PA": "Panama", 
  "PF": "French Polynesia", 
  "PG": "Papua New Guinea", 
  "PE": "Peru", 
  "PK": "Pakistan", 
  "PH": "Philippines", 
  "PN": "Pitcairn", 
  "PL": "Poland", 
  "PM": "Saint Pierre and Miquelon", 
  "ZM": "Zambia", 
  "EH": "Western Sahara", 
  "EE": "Estonia", 
  "EG": "Egypt", 
  "ZA": "South Africa", 
  "EC": "Ecuador", 
  "IT": "Italy", 
  "VN": "Vietnam", 
  "SB": "Solomon Islands", 
  "ET": "Ethiopia", 
  "SO": "Somalia", 
  "ZW": "Zimbabwe", 
  "SA": "Saudi Arabia", 
  "ES": "Spain", 
  "ER": "Eritrea", 
  "ME": "Montenegro", 
  "MD": "Moldova", 
  "MG": "Madagascar", 
  "MF": "Saint Martin", 
  "MA": "Morocco", 
  "MC": "Monaco", 
  "UZ": "Uzbekistan", 
  "MM": "Myanmar", 
  "ML": "Mali", 
  "MO": "Macao", 
  "MN": "Mongolia", 
  "MH": "Marshall Islands", 
  "MK": "Macedonia", 
  "MU": "Mauritius", 
  "MT": "Malta", 
  "MW": "Malawi", 
  "MV": "Maldives", 
  "MQ": "Martinique", 
  "MP": "Northern Mariana Islands", 
  "MS": "Montserrat", 
  "MR": "Mauritania", 
  "IM": "Isle of Man", 
  "UG": "Uganda", 
  "TZ": "Tanzania", 
  "MY": "Malaysia", 
  "MX": "Mexico", 
  "IL": "Israel", 
  "FR": "France", 
  "IO": "British Indian Ocean Territory", 
  "SH": "Saint Helena", 
  "FI": "Finland", 
  "FJ": "Fiji", 
  "FK": "Falkland Islands", 
  "FM": "Micronesia", 
  "FO": "Faroe Islands", 
  "NI": "Nicaragua", 
  "NL": "Netherlands", 
  "NO": "Norway", 
  "NA": "Namibia", 
  "VU": "Vanuatu", 
  "NC": "New Caledonia", 
  "NE": "Niger", 
  "NF": "Norfolk Island", 
  "NG": "Nigeria", 
  "NZ": "New Zealand", 
  "NP": "Nepal", 
  "NR": "Nauru", 
  "NU": "Niue", 
  "CK": "Cook Islands", 
  "XK": "Kosovo", 
  "CI": "Ivory Coast", 
  "CH": "Switzerland", 
  "CO": "Colombia", 
  "CN": "China", 
  "CM": "Cameroon", 
  "CL": "Chile", 
  "CC": "Cocos Islands", 
  "CA": "Canada", 
  "CG": "Republic of the Congo", 
  "CF": "Central African Republic", 
  "CD": "Democratic Republic of the Congo", 
  "CZ": "Czech Republic", 
  "CY": "Cyprus", 
  "CX": "Christmas Island", 
  "CR": "Costa Rica", 
  "CW": "Curacao", 
  "CV": "Cape Verde", 
  "CU": "Cuba", 
  "SZ": "Swaziland", 
  "SY": "Syria", 
  "SX": "Sint Maarten", 
  "KG": "Kyrgyzstan", 
  "KE": "Kenya", 
  "SS": "South Sudan", 
  "SR": "Suriname", 
  "KI": "Kiribati", 
  "KH": "Cambodia", 
  "KN": "Saint Kitts and Nevis", 
  "KM": "Comoros", 
  "ST": "Sao Tome and Principe", 
  "SK": "Slovakia", 
  "KR": "South Korea", 
  "SI": "Slovenia", 
  "KP": "North Korea", 
  "KW": "Kuwait", 
  "SN": "Senegal", 
  "SM": "San Marino", 
  "SL": "Sierra Leone", 
  "SC": "Seychelles", 
  "KZ": "Kazakhstan", 
  "KY": "Cayman Islands", 
  "SG": "Singapore", 
  "SE": "Sweden", 
  "SD": "Sudan", 
  "DO": "Dominican Republic", 
  "DM": "Dominica", 
  "DJ": "Djibouti", 
  "DK": "Denmark", 
  "VG": "British Virgin Islands", 
  "DE": "Germany", 
  "YE": "Yemen", 
  "DZ": "Algeria", 
  "US": "United States", 
  "UY": "Uruguay", 
  "YT": "Mayotte", 
  "UM": "United States Minor Outlying Islands", 
  "LB": "Lebanon", 
  "LC": "Saint Lucia", 
  "LA": "Laos", 
  "TV": "Tuvalu", 
  "TW": "Taiwan", 
  "TT": "Trinidad and Tobago", 
  "TR": "Turkey", 
  "LK": "Sri Lanka", 
  "LI": "Liechtenstein", 
  "LV": "Latvia", 
  "TO": "Tonga", 
  "LT": "Lithuania", 
  "LU": "Luxembourg", 
  "LR": "Liberia", 
  "LS": "Lesotho", 
  "TH": "Thailand", 
  "TF": "French Southern Territories", 
  "TG": "Togo", 
  "TD": "Chad", 
  "TC": "Turks and Caicos Islands", 
  "LY": "Libya", 
  "VA": "Vatican", 
  "VC": "Saint Vincent and the Grenadines", 
  "AE": "United Arab Emirates", 
  "AD": "Andorra", 
  "AG": "Antigua and Barbuda", 
  "AF": "Afghanistan", 
  "AI": "Anguilla", 
  "VI": "U.S. Virgin Islands", 
  "IS": "Iceland", 
  "IR": "Iran", 
  "AM": "Armenia", 
  "AL": "Albania", 
  "AO": "Angola", 
  "AQ": "Antarctica", 
  "AS": "American Samoa", 
  "AR": "Argentina", 
  "AU": "Australia", 
  "AT": "Austria", 
  "AW": "Aruba", 
  "IN": "India", 
  "AX": "Aland Islands", 
  "AZ": "Azerbaijan", 
  "IE": "Ireland", 
  "ID": "Indonesia", 
  "UA": "Ukraine", 
  "QA": "Qatar", 
  "MZ": "Mozambique"
}

export const MOBILE_WIDTH = 1000;

export const HIDE_USER_INFO_WIDTH = 600;

export const MAX_WORD_BANK_MAGNITUDE = 3; 

export const LEVEL_NAMES = [
  "Subzero",
  "Bronze",
  "Silver",
  "Platinum",
  "Gold"
];

export const GET_REAL_MAGNETS = "https://www.amazon.com/gp/product/1890560014/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=1890560014&linkCode=as2&tag=frijio-20&linkId=374c0aab93f33700221b38c9d264bf39";

export const INSTAGRAM = "https://www.instagram.com/frij.io_magnets";

export const FACEBOOK = "https://www.facebook.com/Frijio-103964891550187";

export const MONTHS = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];

export const SWIPE_START_DELTA = 30;

export const SWIPE_EXECUTE_DELTA = 90;

export const SWIPE_DELTA_TO_INCRAMENT = 0.3;

export const CONSTANT_SWIPE_RATE = 160;

export const SWIPE_COMPLETE_TOL = 2;

export const SWIPE_RELOAD_EXECUTE_DELTA = 60;

export const MAX_IMAGE_SIZE = 16000;

export const BLACKLIST_REGEX = new RegExp(/д|и|ж|Ч|Б|paxil|coolhu|cialis|incest|payday|ambien|cialis|adipex|advicer|meridia|adderall|bllogspot|baccarrat|thorcarlson|jrcreations|macinstruct|hydrocodone|carisoprodol|ottawavalleyag|cyclobenzaprine|discreetordering|aceteminophen|phentermine|doxycycline|citalopram|cephalaxin|vicoprofen|lorazepam|oxycontin|oxycodone|percocet|propecia|tramadol|propecia|percocet|cymbalta|lunestra|fioricet|lesbian|lexapro|valtrex|titties|xenical|meridia|levitra|vicodin|ephedra|lipitor|cyclen|viagra|valium|hqtube|ultram|clomid|cyclen|vioxx|zolus|boob|bukkake|dildo|doggystyle|ejaculate|ejaculation|shemale|cumshot|pussy|porno|xanax|bitch|penis|pills|porn|dick|cock|tits|fuck|shit|nigger|nigga|chode|shlong|cunt|jerkoff|jerk-off|masterbate|masterbation|bitch|gay|sex|nude|bdsm|ass/gi);

export const COLOURS = ["Red", "Orange", "Yellow", "Green", "Blue", "Purple", "Brown", "Magenta", "Tan", "Cyan", "Olive", "Maroon", "Navy", "Aquamarine", "Turquoise", "Silver", "Lime", "Teal", "Indigo", "Violet", "Pink", "Gray"];

export const ANIMALS = ["Aardvark", "Albatross", "Alligator", "Alpaca", "Ant", "Anteater", "Antelope", "Ape", "Armadillo", "Donkey", "Baboon", "Badger", "Barracuda", "Bat", "Bear", "Beaver", "Bee", "Binturong", "Bird", "Bison", "Bluebird", "Boar", "Bobcat", "Buffalo", "Butterfly", "Camel", "Capybara", "Caracal", "Caribou", "Cassowary", "Cat", "Caterpillar", "Cattle", "Chameleon", "Chamois", "Cheetah", "Chicken", "Chimpanzee", "Chinchilla", "Chough", "Coati", "Cobra", "Cockroach", "Cod", "Cormorant", "Cougar", "Coyote", "Crab", "Crane", "Cricket", "Crocodile", "Crow", "Cuckoo", "Curlew", "Deer", "Dhole", "Dingo", "Dinosaur", "Dog", "Dogfish", "Dolphin", "Donkey", "Dove", "Dragonfly", "Duck", "Dugong", "Dunlin", "Eagle", "Echidna", "Eel", "Eland", "Elephant", "ElephantSeal", "Elk", "Emu", "Falcon", "Ferret", "Finch", "Fish", "Flamingo", "Fly", "Fox", "Frog", "Gaur", "Gazelle", "Gecko", "Gerbil", "GiantPanda", "Giraffe", "Gnat", "Gnu", "Goat", "Goldfinch", "Goosander", "Goose", "Gorilla", "Goshawk", "Grasshopper", "Grouse", "Guanaco", "GuineaFowl", "GuineaPig", "Gull", "Hamster", "Hare", "Hawk", "Hedgehog", "HermitCrab", "Heron", "Herring", "Hippopotamus", "Hoatzin", "Hoopoe", "Hornet", "Horse", "Hummingbird", "Hyena", "Ibex", "Ibis", "Iguana", "Impala", "Jackal", "Jaguar", "Jay", "Jellyfish", "Jerboa", "Kangaroo", "Kingfisher", "Kinkajou", "Koala", "KomodoDragon", "Kookaburra", "Kouprey", "Kudu", "Lapwing", "Lark", "Lemur", "Leopard", "Lion", "Lizard", "Llama", "Lobster", "Locust", "Loris", "Louse", "Lynx", "Lyrebird", "Macaque", "Macaw", "Magpie", "Mallard", "Mammoth", "Manatee", "Mandrill", "Marmoset", "Marmot", "Meerkat", "Mink", "Mole", "Mongoose", "Monkey", "Moose", "Mosquito", "Mouse", "Myna", "Narwhal", "Newt", "Nightingale", "NineBandedArmadillo", "Octopus", "Okapi", "Opossum", "Orangutan", "Oryx", "Ostrich", "Otter", "Owl", "Oyster", "Panther", "Parrot", "Panda", "Partridge", "Peafowl", "Penguin", "Pheasant", "Pig", "Pigeon", "Pika", "PolarBear", "Pony", "Porcupine", "Porpoise", "PrairieDog", "Pug", "Quail", "Quelea", "Quetzal", "Rabbit", "Raccoon", "Ram", "Rat", "Raven", "RedDeer", "RedPanda", "Reindeer", "Rhea", "Rhinoceros", "Rook", "Salamander", "Salmon", "SandDollar", "Sandpiper", "Sardine", "SeaLion", "Seahorse", "Seal", "Shark", "Sheep", "Shrew", "Siamang", "Skunk", "Sloth", "Snail", "Snake", "Spider", "Squid", "Squirrel", "Starling", "Stegosaurus", "Swan", "Tamarin", "Tapir", "Tarsier", "Termite", "Tiger", "Toad", "Toucan", "Turaco", "Turkey", "Turtle", "Umbrellabird", "Vicuna", "Vinegaroon", "Viper", "Vulture", "Wallaby", "Walrus", "Wasp", "WaterBuffalo", "Waxwing", "Weasel", "Whale", "Wobbegong", "Wolf", "Wolverine", "Wombat", "Woodpecker", "Worm", "Wren", "Yak", "Zebra"];

export const USERNAME_CHARACTERS = "0123456789";

export const BILLION = 1000000000;

export const MILLION = 1000000;

export const THOUSAND = 1000;

export const POST_SCORE_BONUS = 20;

export const COMMENT_SCORE_BONUS = 0;